export default __webpack_public_path__ + "static/media/speedy.bf45049a.png";